import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index/:id',
      name: 'tcIndex',
    },
    {
      path: '/apply/:id',
      name: 'tcApply',
    },
    {
      path: '/i/:id/:code',
      name: 'tcInvite',
    },
    {
      path: '/t/:id/',
      name: 'tcTeam',
    },
    {
      path: '/g/:id/',
      name: 'tcGrade',
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/index.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue')
    },
    {
      path: '/apply',
      name: 'apply',
      component: () => import('./views/apply.vue')
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: () => import('./views/certificate.vue')
    },
    {
      path: '/score',
      name: 'score',
      component: () => import('./views/score.vue')
    },
    {
      path: '/team',
      name: 'team',
      component: () => import('./views/team.vue')
    },
    {
      path: '/add-invite',
      name: 'addInvite',
      component: () => import('./views/add-invite.vue')
    },
    {
      path: '/receive',
      name: 'receive',
      component: () => import('./views/receive.vue')
    },
    {
      path: '/user-info',
      name: 'userInfo',
      component: () => import('./views/user-info.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('./views/success.vue')
    },
  ]
})
